module.exports = __webpack_public_path__ + "img/07.fb030f2c.png";